angular.module('app.financeiro').factory('outrosPagamentosFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'OutrosPagamentos';

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _liberar = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Liberar', dto);
    };
    var _update = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Update', dto);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listarOutrosPagamentos = function (search, options, dtInicio, dtTermino, situacao, segmento, codigoRede, nroProposta) {

        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        dto.parms.push({ "name": "IDSegmento", "value": segmento });
        dto.parms.push({ "name": "CodigoRede", "value": codigoRede });
        dto.parms.push({ "name": "NroProposta", "value": nroProposta });

        $("[kendo-grid][data-role='grid']").data("kendoGrid").parms = dto.parms;

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarOutrosPagamentos', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _pagar = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Pagar', dto);
    };

    var _tornarPendentePagamento = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/TornarPendentePagamento', dto);
    };

    var _verificaPropostaLancamentoEnviadaBanco = function (codigoPropostaLancamento) {
        var dto = {};
        dto.id = codigoPropostaLancamento;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/VerificaPropostaLancamentoEnviadaBanco', dto);
    };


    var factory = {};

    factory.liberar = _liberar;
    factory.update = _update;
    factory.delete = _delete;
    factory.findRecord = _findRecord;
    factory.listarOutrosPagamentos = _listarOutrosPagamentos;
    factory.pagar = _pagar;
    factory.tornarPendentePagamento = _tornarPendentePagamento;
    factory.verificaPropostaLancamentoEnviadaBanco = _verificaPropostaLancamentoEnviadaBanco;

    return factory;
}]);
